import { useContext } from "react";
import { UserContext } from "./context";
export function useUserContext() {
    var context = useContext(UserContext);
    return context;
}
export function useAssertUserContext() {
    var currentUser = useUserContext().currentUser;
    if (!currentUser) {
        throw new Error("You must be logged in.");
    }
    return currentUser;
}
